const theme = {
  black: "#000000",
  white: "#FFFFFF",
  oxBlood: "#2E0B0D",
  merino: "#E1DACE",
  offWhite: "#FDF8EB",
};

export default theme;
